import tinycolor from 'tinycolor2';
import { sortFn } from 'color-sorter';

export const COLOR_TRANSPARENT = '#00000000';

export const isValidColor = ( value ) => {
    let color = tinycolor( value );
    if ( !color.isValid() ) {
        color = tinycolor( '#' + value );
    }
    return color.isValid();
};

export const getHexColor = ( value ) => {
    let color = tinycolor( value );
    if ( !color.isValid() ) {
        color = tinycolor( '#' + value );
    }
    if ( color.isValid() ) {
        return color.toHexString();
    }
    return '';
};

export const sortColors = ( colors ) => {
    const hex = [];
    const hexMap = {};
    // create an array of hex values and a map of hex value to color
    colors.forEach( c => {
        hex.push( c.hex );
        hexMap[ c.hex ] = c;
    } );
    // sort the hex values and map that back to an array of colors
    const sortedColors = [];
    hex.sort( sortFn ).forEach( h => {
        sortedColors.push( hexMap[ h ] );
    } );
    return sortedColors;
};
